module.exports = __webpack_public_path__ + "media/images/home/hero_widget_mobile_bg_old-20167c6978f18fa2237dc9793d511a9d.jpg";